import { forwardRef } from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../utils/cn';

export const badgeVariants = cva(
	"inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
	{
		variants: {
			variant: {
				default:
					"border-transparent bg-foreground text-background hover:bg-foreground/80",
				brand:
					"border-transparent bg-brand-50 text-brand-700 dark:bg-brand-500/10 dark:text-brand-200",
				secondary:
					"border-transparent bg-muted text-foreground",
				destructive:
					"border-transparent bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-300",
				outline: "text-foreground border-border",
				success:
					"border-transparent bg-green-100 text-green-700 dark:bg-green-500/15 dark:text-green-300",
				warning:
					"border-transparent bg-amber-100 text-amber-700 dark:bg-amber-500/15 dark:text-amber-300",
			},
			size: {
				default: "px-2.5 py-0.5 text-xs",
				sm: "px-2 py-0.5 text-xs",
				lg: "px-3 py-1 text-sm",
			}
		},
		defaultVariants: {
			variant: "default",
			size: "default"
		},
	}
);

export const Badge = forwardRef(({ className, variant, size, ...props }, ref) => {
	return (
		<div ref={ref} className={cn(badgeVariants({ variant, size }), className)} {...props} />
	);
});
Badge.displayName = "Badge"; 